module.exports = __webpack_public_path__ + "bf5190b01dcacdb9df784750d56ee382.pdf";